export const ORDER = "order"
export const ORDERS = "orders" as const
export const ORDER_LINES = "order-lines" as const



// WEBPACK FOOTER //
// ./src/state/order/Constants.ts